import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { usePlayerContext } from "../../context/PlayerContext";
import { useCommentsContext } from "../../context/CommentsContext";
import { useQuestionsContext } from "../../context/QuestionsContext";
import { useStreamContext } from "../../context/StreamContext";
import { usePollsContext } from "../../context/PollsContext";
import { useModalContext } from "../../context/ModalContext";
import { useScreenOrientation } from "../../hooks/useScreenOrientation";
import Module from "./Module";
import Tabs, { MODULE_COMMENTS, MODULE_QUESTIONS, MODULE_POLLS } from "./Tabs";
import BottomSheet from "./BottomSheet";
import ButtonQuestionWriteForm from "./ButtonQuestionWriteForm";
import ButtonQuestionWriteFormWrapper from "../QuestionMessages/ButtonQuestionWriteFormWrapper";

import "./style.scss";

export default ({
    settings,
    onChangeTab,
    isFullscreenChat,
    isOpenModule,
    isTabletViewFixed = true,
    ModuleMobileComponent = BottomSheet,
    isWidgetBottomSidebar = false,
}) => {
    const moduleRef = useRef(null);
    const { event } = useEventContext();
    const { stream } = useStreamContext();
    const { modalIsOpen } = useModalContext();
    const { enabled: commentsEnabled } = useCommentsContext();
    const { isShowBlockQuestions: questionsEnabled } = useQuestionsContext();
    const { enabled: pollsEnabled } = usePollsContext();
    const {
        setSideModuleEnabled,
        currentModule,
        setCurrentModule,
        isPlayerWidget,
        tabletView,
    } = usePlayerContext();
    const { isOrientationLandscape } = useScreenOrientation();
    const className = 'side-module';
    const streamId = stream?.id;

    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);

    const modules = [
        { name: MODULE_COMMENTS, enabled: commentsEnabled, module: event.moduleComment, },
        { name: MODULE_QUESTIONS, enabled: questionsEnabled, module: event.moduleQuestion, },
        { name: MODULE_POLLS, enabled: pollsEnabled },
    ].filter(item => item.enabled).sort((a, b) => b.module?.order - a.module?.order);

    const defaultModule = modules[0]?.name ?? null;

    useEffect(() => {
        if (!currentModule && (isOpenModule || !tabletView || isWidgetBottomSidebar)) {
            setCurrentModule(defaultModule);
        }
    }, []);

    // Устанавливаем доступный модуль
    useEffect(() => {
        if ((currentModule && !modules.find(item => item.name === currentModule))) {
            setCurrentModule(defaultModule);
        }
    }, [streamId, currentModule, modules, tabletView, isOpenModule, isOrientationLandscape]);

    useEffect(() => setSideModuleEnabled(!!modules.length), [modules.length])

    useEffect(() => {
        if (onChangeTab) {
            onChangeTab(currentModule);
        }
    }, [currentModule]);

    const handleOpenQuestionWriteForm = () => {
        setCurrentModule(MODULE_QUESTIONS);
    }

    const changeCurrentModule = (module) => {
        if (params.get('module-active')) {
            navigate(`${location.pathname}`);
        }

        setCurrentModule(module);
    }

    if (!modules.length) {
        return null;
    }

    //Рендер фиксированных табов внизу экрана для планшетов и горизонтальных мобилок
    const isTabletViewFixedTabs = !currentModule && (tabletView || window.innerWidth < 750 || isWidgetBottomSidebar);

    return (
        <div className={`${className} ${currentModule === null ? '-information' : ''}`} ref={moduleRef}>
            <div className="side-module-content">
                            {(tabletView || isWidgetBottomSidebar) ? <>
                {isTabletViewFixedTabs && <Tabs
                    modules={modules.map(({ name }) => name)}
                    isTabletView
                    isTabletViewFixed={isTabletViewFixed}
                    currentModule={currentModule}
                    setCurrentModule={changeCurrentModule}
                />}
                {!!currentModule && (
                    <ModuleMobileComponent
                        isNotPadding={isPlayerWidget}
                        isFullscreen={isFullscreenChat}
                        moduleRef={moduleRef}
                        modalIsOpen={modalIsOpen}
                        modules={modules}
                        currentModule={currentModule}
                        setCurrentModule={changeCurrentModule}
                        settings={settings}
                        handleOpenQuestionWriteForm={handleOpenQuestionWriteForm}
                        isClose={!isOpenModule}
                        isWidgetBottomSidebar={isWidgetBottomSidebar}
                    />
                )}
            </> : <>
                <div className={`${className}-block`}>
                    <Tabs
                        modules={modules.map(({ name }) => name)}
                        currentModule={currentModule}
                        setCurrentModule={changeCurrentModule}
                    />
                    <div className="modules-container">
                        <Module
                            module={currentModule}
                            moduleRef={moduleRef}
                        />
                    </div>
                </div>

                <ButtonQuestionWriteFormWrapper
                    moduleRef={moduleRef}
                    settings={settings}
                    onClick={handleOpenQuestionWriteForm}
                    ButtonComponent={ButtonQuestionWriteForm}
                />
            </>
            }
            </div>
        </div>
    );
}
